export default class VesselData {
    constructor(
        id,
        theyrId,
        companyId,
        description,
        imoIdentifier,
        plugin,
        pluginParams,
        modelFouling,
        modelTrim
    ) {
        this.id = id
        this.theyrId = theyrId
        this.companyId = companyId
        this.description = description
        this.imoIdentifier = imoIdentifier
        this.plugin = plugin
        this.pluginParams = pluginParams
        this.modelFouling = modelFouling
        this.modelTrim = modelTrim
    }
}